import article from './article';
import magazine from './magazine';
import storyboard from './storyboard';
import video from './video';
import topic from './topic';
import profile from './profile';
import newsletter from './newsletter';
import newslettersLanding from './newsletters-landing';
import home from './home';
import signup from './signup';
import login from './login';

/**
 * NOTE: More than likely if you're adding/modifying this list, you also want to check ../social-graph-description/index.js
 * Verify if there is an exception to this rule.
 */
export default [
  signup,
  login,
  newslettersLanding,
  newsletter,
  video,
  article,
  magazine,
  storyboard,
  topic,
  profile,
  home,
];
